


export const jurFormVoList = JSON.stringify([
    {
        isForm: 1,
        isShowForm: 0,
        jciId: 11717,
        jciName: "出库申请主信息表单",
        jciType: 1,
        index: 0,
        jurId: "1698307975196",
        jurconfigform: [

            {
                chineseField: "销售单位",
                defaultValue: "",
                entityField: "cmName",
                extractId: null,
                fieldType: "search",
                setField: "cmName,cmId",
                fieldWeight: 180,
                searchId: '3391151360249856',
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "使用单位名称",
                defaultValue: "",
                entityField: "usecmName",
                extractId: null,
                fieldType: "search",
                setField: "usecmName,usecmId",
                fieldWeight: 180,
                searchId: '3391151360249856',
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "业务员",
                defaultValue: "",
                entityField: "opmName",
                extractId: null,
                searchId: '4444770562019328',
                fieldType: "search",
                fieldWeight: 180,
                setField: "opmName,opmId",
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "对方业务员",
                defaultValue: "",
                entityField: "salesName",
                extractId: null,
                searchId: '8820873997127680',
                fieldType: "search",
                fieldWeight: 180,
                setField: "salesName,salesId",
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "使用对方业务员",
                defaultValue: "",
                entityField: "usesalesName",
                extractId: null,
                searchId: '8820873997127680',
                fieldType: "search",
                fieldWeight: 180,
                setField: "usesalesName,usesalesId",
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "使用单位地址",
                defaultValue: "",
                entityField: "usecaiAddress",
                extractId: null,
                searchId: '423073365168128',
                fieldType: "search",
                setField: "usecaiId,usecaiAddress",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "货主名称",
                defaultValue: "",
                entityField: "coName",
                extractId: null,
                fieldType: "search",
                searchId: '4414428383875072',
                fieldWeight: 180,
                setField: "coName,coId",
                focusField: "",
                isChange: 1, isUpdate: 0,isRequired:1
            },
            {
                chineseField: "手术时间",
                defaultValue: "",
                entityField: "operationTime",
                extractId: null,
                fieldType: "date",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "科室",
                defaultValue: "",
                entityField: "roomName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人姓名",
                defaultValue: "",
                entityField: "patientName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "年龄",
                defaultValue: "",
                entityField: "ageNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "住院号",
                defaultValue: "",
                entityField: "courtNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "床位号",
                defaultValue: "",
                entityField: "bunkCode",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人电话",
                defaultValue: "",
                entityField: "patientPhone",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "身份证号",
                defaultValue: "",
                entityField: "idcardNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "手术类型",
                defaultValue: "",
                entityField: "surgicalType",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "术者",
                defaultValue: "",
                entityField: "surgeonName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "备注",
                defaultValue: "",
                entityField: "wsRemark",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },

        ]
    }

]
)
export const tabledata = [
    {
        chineseField: "单号",
        defaultValue: "",
        entityField: "woamId",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0,
        isUpdate: 0
    },
    {
        chineseField: "商品编号",
        defaultValue: "",
        entityField: "bgmCode",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "商品名称",
        defaultValue: "",
        entityField: "bgmName",
        extractId: null,
        fieldType: "search",
        fieldWeight: 180,
        focusField: "",
        nosetField: "woadPnumber,psprice,psmoney,price,money,woadRemark",
        riftField: "bgmId",
        searchId: 919354910904320,
        setField: "bgmName,bgmId",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "规格",
        defaultValue: "",
        entityField: "spec",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "生产厂商",
        defaultValue: "",
        entityField: "manufacturer",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "使用数量",
        defaultValue: "",
        entityField: "useNum",
        extractId: null,
        fieldType: "string",
        fieldWeight: 110,
        focusField: "keydown",
        isChange: 0, isUpdate: 0
    },

    {
        chineseField: "包装单位",
        defaultValue: "",
        entityField: "bgpUnitmeasurement",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "装箱规格",
        defaultValue: "",
        entityField: "packingSpec",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "批号",
        defaultValue: "",
        entityField: "batchno",
        extractId: null,
        fieldType: "string",
        fieldWeight: 120,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "生产日期",
        defaultValue: "",
        entityField: "prodate",
        extractId: null,
        fieldType: "date",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "失效日期",
        defaultValue: "",
        entityField: "expidate",
        extractId: null,
        fieldType: "date",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "灭菌批号",
        defaultValue: "",
        entityField: "sterBatchno",
        extractId: null,
        fieldType: "string",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "产地",
        defaultValue: "",
        entityField: "placeorigin",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },



]